import { GetInvitacionesAsesoriaDtoProps } from "api/DTOs/GetInvitacionesAsesoriaDto"
import { convertImgBase64 } from "utils/convertBase64"
import { UUIDType } from "uuid"

export interface InvitacionesAsesoriaAdapted {
  id: UUIDType | string
  logo?: string
  provinciaRegistroMercantil?: string | null
  razonSocial?: string | null
}
export const asesoriasInvitacionesAdapter = (
  data: GetInvitacionesAsesoriaDtoProps[]
): InvitacionesAsesoriaAdapted[] =>
  data?.map((item) => ({
    id: item.id,
    logo: convertImgBase64({
      base64: item.logo?.base64,
      mediaType: item.logo?.mediaType,
    }),
    provinciaRegistroMercantil: item.provinciaRegistroMercantil,
    razonSocial: item.razonSocial,
  }))
